"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEntityRequiredFields = void 0;
var lodash_1 = require("lodash");
var REQUIRED_ENTITY_FIELDS = [
    'sub_building',
    'apt_number',
    'rooms',
    'area',
    'floor',
    'price',
    'currency',
    'availability',
    'bedrooms',
    'apartment_plan',
    'floor_plan',
    'building_plan',
];
var validateEntityRequiredFields = function (formikProps) {
    var _a;
    if ((_a = formikProps.errors) === null || _a === void 0 ? void 0 : _a.apartment_info) {
        return !!formikProps.errors.apartment_info.filter(function (item, index) {
            if (!lodash_1.isUndefined(item)) {
                REQUIRED_ENTITY_FIELDS.filter(function (item) {
                    formikProps.setFieldTouched("apartment_info[" + index + "][" + item + "]", true, true);
                });
                return !!item;
            }
        });
    }
    return false;
};
exports.validateEntityRequiredFields = validateEntityRequiredFields;
